import { useCallback, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  skipToNextScene,
  selectScene,
  selectIsShowScene,
  selectSceneArt

} from '../openingSceneSlice.js'

import { selectIsNoDelay } from '../../settings/settingsSlice.js'

import Reader from '../../../reader/Reader.js'

export default function OpeningSceneScene () {
  const dispatch = useDispatch()
  const scene = useSelector(selectScene)
  const sceneArt = useSelector(selectSceneArt)
  const isShowScene = useSelector(selectIsShowScene)

  const onClose = useCallback(() => {
    dispatch(skipToNextScene())
  }, [dispatch, skipToNextScene])

  return (
    <div>
      <Reader scene={scene} sceneArt={sceneArt} storyIcon='handcuffs.svg' isOpen={isShowScene} onClose={onClose} />
    </div>
  )
}
